/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useState,memo, useRef } from 'react';
import DateRange from './DateRange';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import { useSearchParams } from 'react-router-dom';

const Filter = ({FilterData, filterCount,
    directoryPage = false,
    radioButton,
    dateRangeFilterName,
    FilterCheckbox, handleApplyFilter, setIsFilterOpen,handleSelectObject,selectedFilter, setSelectedFilter,tooltip, ref, filterFromPage}) => {
    const [selectedDates, setSelectedDates] = useState({})
    const [searchParams, setSearchParams] = useSearchParams()
    const handleCheck = () => {
        const startDate =selectedDates.start_date !== undefined ? selectedDates.start_date : searchParams.get('start_date') === null ? selectedDates.start_date : searchParams.get('start_date');
        const endDate = selectedDates.end_date !== undefined ? selectedDates.end_date : searchParams.get('end_date') === null ? selectedDates.end_date : searchParams.get('end_date');
        const fomratedStartDate = new Date(endDate).toDateString().split('00:')[0]
        const formatedEndDate = new Date(startDate).toDateString().split('00:')[0]
        if(new Date(formatedEndDate) > new Date(fomratedStartDate) ){
            return true
        } else{
            return false
        }
    }
    const closeRef = useRef();
    useOnClickOutside(closeRef, () => {
        setIsFilterOpen(false)
    })
    const handleInputValue = (item, type) => {
        let value = ""
        switch (item) {
        case "true":
            if(selectedFilter === "status") {
                value = 'Active'
            }
            break;
        case "false":
            if(selectedFilter === "status") {
                value = 'Inactive'
            }
            break;
        case "fee":
            if(selectedFilter === "invoice_type") {
                value = 'Fee Invoice'
            }
            break;
        case "inventory":
            if(selectedFilter === "invoice_type") {
                value = 'Inventory Invoice'
            }
            break;
        
        default:
            break;
        }
        if(value === "") {
            value = item
        }
        return type === "tool_tip" ? value : value?.length>25 ?`${value.substring(0, 25)}...`: value
    }

    const handleFilterAttrs = (key) => {
        let val = {}
        switch (filterFromPage) {
        case "Transfer_Inwards":
            val = {height : "h-[170px]", class: "top8", width:'wid-175px'}
            break;
        case "Fee_Structures":
            val = {height : "h-[170px]", class: "top7", width:'wid-190px'}
            break;
        case "Payroll":
            val = {height : "h-[170px]", class: "top7", width:'w-[220px]'}
            break;
        case "Purchase_Order":
            val = {height : "h-[170px]", class: "top7", width:'wid-190px'}
            break;
        case "Transfer_Outwards":
            val = {height : "h-[170px]", class: "top8", width:'wid-175px'}
            break;
        case "Branches_List":
            val = {height : "h-[220px]", class: "top11", width:'wid-190px'}
            break;
        default:
            val = {height : "h-[170px]", class: "top", width:'wid-190px'}
            break;
        }
        return val[key]
    }

    const [dateError, setdateError] = useState(false)
    return (
        /*${filterFromPage}-do not remove this-Anitha*/
        <div class={`filter_btn_drp_dwn ${filterFromPage} ${filterCount ===0 ? '' : 'filterCnt'} ${handleFilterAttrs("class")}   shadow-s1  filter_modal`} ref={closeRef}>
            <div class="flex">
                <ul role="tablist" data-te-nav-ref="" className={`flex list-none flex-col flex-wrap h-fit filter_btn_drp_dwn_div1
                ${['Transfer_Outwards', 'Transfer_Inwards'].includes(filterFromPage) ? "min-w-[120px]" : 
            (['Purchase_Order','Branches_List'].includes(filterFromPage) ? "min-w-[95px]" : "min-w-[110px]")}`}>
                    {Object.keys(FilterData).map((item) => {
                        //for student directory page - AY filter
                        const hideFilterOptions = 
                            item === 'academic_year' && directoryPage && searchParams.get('status') === 'active' &&
                            (FilterData.academic_year.length === 1) ;
                                                 
                        selectedFilter = hideFilterOptions ? 'class_' :selectedFilter;

                        return !hideFilterOptions ? (
                            <li role="presentation" class="flex-grow text-center" key={item}>
                                <button id={item} 
                                    onClick={() => {
                                        setSelectedFilter(item); 
                                        setdateError(false)
                                    }}  
                                    class={`text-start relative block text-sm font-normal w-full ${selectedFilter === item ? "text-[#106EB4]" : "text-[#4D555B]"} mb-3`}>{dateRangeFilterName === undefined? item.replace(/_/g, ' ').toLowerCase().replace(/(?:^|\s)\S/g, function(c) { return c.toUpperCase(); }) : dateRangeFilterName}</button>
                            </li>
                        ) : null;
                    })}
                </ul>
                <div className={selectedFilter !== "date_range" || selectedFilter !== 'po_date' ? `filter_btn_drp_dwn_div2 ${handleFilterAttrs('width')}` : `filter_btn_drp_dwn_div2 ${handleFilterAttrs('width')}`}>
                    <div class="hidden transition-opacity duration-150 ease-linear data-[te-tab-active]:block opacity-100" id="tabs-home03" role="tabpanel" aria-labelledby="tabs-home-tab03" data-te-tab-active="">
                        <div class={` ${handleFilterAttrs('height')} overflow-auto scroll-smooth scroll-bar`}>
                            <div class={"w-full"}>
                                {(selectedFilter !== "date_range" && selectedFilter !== 'po_date' && selectedFilter !== "custom" && selectedFilter !== "processed_date")? FilterData[selectedFilter]?.length === 0 ? 
                                    <div className='text-[13px] text-center pt-[35px]'>
                                        {"No options available. To begin filtering, add students with necessary AY details."}
                                    </div> 
                                    : FilterData[selectedFilter]?.map((item,  i) => (
                                        ((radioButton !== undefined && radioButton) ? 
                                            <div key={item._id} onChange={(e) => handleSelectObject(selectedFilter === "status" ? item.toLowerCase() : item,'',selectedFilter)} className="relative custom-radioBlue mb-3 flex items-center">
                                                <input
                                                    type='radio'
                                                    id={item}
                                                    name="radio"
                                                    autocompleted={item}
                                                    checked={
                                                        selectedFilter === "financial_year" ? FilterCheckbox[selectedFilter]?.some(fy => fy.split('(')[0].trim() === item.split('(')[0].trim()) 
                                                            
                                                            : FilterCheckbox[selectedFilter]?.includes(selectedFilter === "status" ? item.toLowerCase() : item)
                                                    }
                                                    onChange={(e) => handleSelectObject(selectedFilter === "status" ? item.toLowerCase() : item, '', selectedFilter)}
                                                />
                                                <label 
                                                    title={handleInputValue(item, "tool_tip")} 
                                                    htmlFor={item} 
                                                    id={'filter'+i}
                                                    name="radio"
                                                    
                                                >{handleInputValue(item)}</label>
                                            </div>
                                            :

                                            <div class={`relative checkbox custom-checkBoxBlue1 mb-3 more-lines flex ${item?.length > 12 ? 'line-wrap' : ''}`} key={item}>
                                                <input 
                                                    type="checkbox" 
                                                    id={item} 
                                                    autocompleted={item} 
                                                    checked={selectedFilter === "academic_year" && !directoryPage  ? FilterCheckbox[selectedFilter]?.some(ay => ay.split('(')[0].trim() === item.split('(')[0].trim())  : FilterCheckbox[selectedFilter]?.includes(selectedFilter === "status" ? item.toLowerCase() : item)} 
                                                    onChange={(e) => handleSelectObject(selectedFilter === "status" ? item.toLowerCase() : item,'',selectedFilter)}
                                                />
                                                <label 
                                                    title={handleInputValue(item, "tool_tip")} 
                                                    htmlFor={item} 
                                                    
                                                >{handleInputValue(item)}</label>
                                            </div>)
                                    ))
                                    : <DateRange setSelectedDates={setSelectedDates} dateError={dateError} setdateError={setdateError} handleCheck={handleCheck} handleSelectObject={handleSelectObject} setIsFilterOpen={setIsFilterOpen} FilterCheckbox={FilterCheckbox}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-center pt-[10px] mt-1 shadow-top">
                <button type="button"  onClick={()=>{
                    handleApplyFilter(false); setIsFilterOpen(false)}} class="clr-btn">Clear All
                    
                </button>
                <button onClick={()=>{
                    if(handleCheck()){
                        setdateError(true)
                        return
                    } else {
                        handleApplyFilter(true);
                        setIsFilterOpen(false)
                    }
                }

                } type="button" id ="apply_filter" class="aply-fltr-btn">Apply Filter(s)
                </button>
            </div> 
        </div>
    );
}

export default memo(Filter);
